export default __webpack_public_path__ + "static/media/mppic.c4f42dff.png";